import cn from "classnames"

import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { DetectionStateIcon } from "../DetectionStateIcon"

import styles from "./RuleCard.module.scss"

import type { RuleDTO } from "@/domain/adr"

export const PopoverRuleCard = (
  props: RuleDTO & { subList?: boolean; disabled?: boolean }
) => {
  const hasDescription = props.id === "POTENTIAL_EXPLOIT_CVE"
  const align = hasDescription ? "start" : "center"
  const secondaryText = cn(styles.text, styles.textSecondary)
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.adr.management"
  })

  return (
    <Flex
      gap={8}
      align={align}
      className={cn(styles.popoverItem, {
        [styles.popoverItemDisabled]: props.disabled
      })}
    >
      {!props.disabled && (
        <DetectionStateIcon isSuccess={!props.detectedIncidentsCount} />
      )}
      <Flex vertical gap={4}>
        <Flex gap={8} align="center" justify="space-between">
          <span className={cn(styles.text, styles.popoverText)}>
            {props.name}
          </span>
          {props.subList && (
            <span className={cn(secondaryText, styles.popoverText)}>
              {t("experimental")}
            </span>
          )}
        </Flex>
        {hasDescription && (
          <span className={cn(secondaryText)}>
            {t("requiresLearningPeriod")}
          </span>
        )}
      </Flex>
    </Flex>
  )
}
